import { isLoggedin } from "../../app/helpers/helper";
import { CartFloatingIcon, CartRemoveItemIcon } from "../../assets/icons/CartIcons";
import { useCart } from "../../app/context/Cart/CartContext";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const CartButton = () => {
  const { cartItems, removeFromCart } = useCart();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const cartRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let isMounted = true;

    const checkLoginStatus = async () => {
      const loggedIn = await isLoggedin();
      if (isMounted) {
        setIsLoggedIn(loggedIn);
      }
    };

    checkLoginStatus();

    const handleFocus = () => {
      checkLoginStatus();
    };

    if (typeof window !== "undefined") {
      window.addEventListener("focus", handleFocus);
    }

    return () => {
      isMounted = false;
      if (typeof window !== "undefined") {
        window.removeEventListener("focus", handleFocus);
      }
    };
  }, [location.pathname]);

  const isVerticalPlayerScreen = (() => {
    const { pathname } = location;
    const allowedPrefixes = [
      "/vertical-player",
      "/vertical-video",
      "/post",
      "/discover/content",
      "/discover/series",
      "/content",
      "/series",
      "/feed",
    ];
    return allowedPrefixes.some((prefix) => pathname.startsWith(prefix));
  })();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        cartRef.current &&
        event.target instanceof Node &&
        !cartRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname, isLoggedIn]);

  if (!isLoggedIn || !isVerticalPlayerScreen) {
    return null;
  }

  return (
    <div className="cart_button_container" ref={cartRef}>
      <button
        className="cart_floating_button"
        type="button"
        title="Cart"
        aria-label="Cart"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <CartFloatingIcon />
        {cartItems.length > 0 && (
          <span className="cart_count">{cartItems.length}</span>
        )}
      </button>

      {isOpen && (
        <div className="cart_dropdown">
          {cartItems.length === 0 ? (
            <p className="cart_empty">Your cart is empty</p>
          ) : (
            <ul className="cart_list">
              {cartItems.map((item: any, index: number) => {
                const identifier =
                  item?._id || item?.productId || item?.id || index;
                const imageSrc =
                  item?.imageUrl || item?.productImage || item?.thumbnailUrl;
                const title =
                  item?.productName || item?.name || item?.title || "Item";

                return (
                  <li className="cart_list_item" key={identifier}>
                    <div className="cart_item_info">
                      {imageSrc && (
                        <img
                          src={imageSrc}
                          alt={title}
                          className="cart_item_image"
                        />
                      )}
                      <div className="cart_item_text">
                        <span className="cart_item_title">{title}</span>
                        {item?.mrp && (
                          <span className="cart_item_price">${item?.mrp}</span>
                        )}
                      </div>
                    </div>
                    <button
                      type="button"
                      className="cart_remove_button"
                      onClick={() => removeFromCart(item)}
                    >
                      <CartRemoveItemIcon />
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default CartButton;
